<template>
  <div v-if="access !== null">
    <kode-qurban-popup
      v-if="passParent !== null"
      :activate="activeKodeQurban"
      @callback="callBackKodeQurban"
      @withClose="loadData"
      :passData="passParent"
    ></kode-qurban-popup>
    <hewan-qurban-popup
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
    />
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <header class="w-full">
        <div class="mb-base mt-4 vx-row justify-between items-top">
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
            <span class="text-black text-2xl">Tabel Qurban</span>
          </section>
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
            <vs-button @click="openPopUp(null)" v-if="access.create === 1"
              >Tambah</vs-button
            >
          </section>
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="dialogDelete" v-if="access.delete === 1">
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="w-full flex justify-end gap-2 flex-wrap items-center">
              <vs-input v-model="search" placeholder="Search..." />
            </div>
          </section>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </header>

      <main ref="loadQurban">
        <vs-table stripe :data="qurbans" v-model="selected" :max-items="limit" multiple>
          <template slot="thead">
            <vs-th>Foto</vs-th>
            <vs-th>Judul</vs-th>
            <vs-th>Hewan</vs-th>
            <vs-th>Harga</vs-th>
            <vs-th>Mulai</vs-th>
            <vs-th>Selesai</vs-th>
            <vs-th>Jenis</vs-th>
            <vs-th>Status Aktif</vs-th>
            <vs-th>Aksi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].file">
                <img
                  key="indextr"
                  :src="
                    data[indextr].file
                      ? data[indextr].file.includes('http')
                        ? data[indextr].file
                        : `${url.baseFl}/${data[indextr].file}`
                      : emptyImage
                  "
                  alt="user-img"
                  class="rounded-lg shadow-md cursor-pointer block"
                />
              </vs-td>
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>
              <vs-td :data="data[indextr].hewan">
                {{ data[indextr].hewan }}
              </vs-td>
              <vs-td :data="data[indextr].nominal">
                {{ data[indextr].nominal | toCurrency }}
              </vs-td>
              <vs-td :data="data[indextr].mulai">
                {{ data[indextr].mulai }}
              </vs-td>
              <vs-td :data="data[indextr].selesai">
                {{ data[indextr].selesai }}
              </vs-td>
              <vs-td :data="data[indextr].status">
                {{ data[indextr].status == 1 ? "Full" : "1/7" }}
              </vs-td>
              <vs-td
                :data="data[indextr].status_active"
                :class="data[indextr].status_active == 1 ? 'text-success' : 'text-danger'"
              >
                {{ data[indextr].status_active == 1 ? "Aktif" : "Tidak Aktif" }}
              </vs-td>
              <vs-td>
                <div class="flex justify-start gap-2">
                  <vs-tooltip text="Edit">
                    <vs-button
                      v-if="access.update === 1"
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click="openPopUp(data[indextr])"
                    >
                    </vs-button>
                  </vs-tooltip>
                  <vs-tooltip text="Kode Qurban">
                    <vs-button
                      color="warning"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-menu"
                      @click="openKodeQurban(data[indextr])"
                    >
                    </vs-button>
                  </vs-tooltip>
                  <vs-tooltip text="Delete">
                    <vs-button
                      v-if="access.delete === 1"
                      color="danger"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="dialogDelete(data[indextr].id, data[indextr].name)"
                    >
                    </vs-button>
                  </vs-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </main>
      <footer>
        <div class="justify-end mt-2">
          <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
        </div>
      </footer>
    </vx-card>
  </div>
</template>

<script>
import HewanQurbanPopup from "@/views/qurban/component/HewanQurbanPopup.vue";
import KodeQurbanPopup from "@/views/qurban/component/KodeQurbanPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    KodeQurbanPopup,
    HewanQurbanPopup,
  },
  data() {
    return {
      emptyImage,
      url,
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      currentPg: 1,
      params: {},
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      activeKodeQurban: false,
      passParent: null,
      passData: null,
      selected: [],
      access: null,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      qurbans: [],
      search: "",
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    totalPage() {
      let pages = this.$store.state.qurban.totalRecords / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  watch: {
    search() {
      if (this.search !== "") {
        this.params = {
          search: this.search,
          filter: "name",
        };
      } else {
        this.params = {};
      }

      this.getData();
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  methods: {
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    callBackKodeQurban(val) {
      this.activeKodeQurban = val;
      this.passParent = null;
    },
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    openKodeQurban(item) {
      this.activeKodeQurban = true;
      this.passParent = item;
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadQurban,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("qurban/cudQurban", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Hewan Qurban ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadQurban);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadQurban,
        color: "primary",
      });
      let profileObj = {};
      if (this.profile.level.id !== 2) {
        profileObj = {
          user_id: this.profile.id,
        };
      }
      this.$store
        .dispatch("qurban/getQurban", {
          ...this.params,
          ...this.pagination,
          ...profileObj,
        })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadQurban);
          this.qurbans = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadQurban);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getKatZIS() {
      this.$store
        .dispatch("zis/getKatZIS", { price_custom: 1, akses_admin: 1 })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getSubKatZIS() {
      this.$store.dispatch("zis/getSubKatZIS", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
  },
  mounted() {
    this.getSubKatZIS();
    this.getKatZIS();
    this.getData();
  },
  created() {
    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/qurban"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/qurban"
        );
      }
    }
  },
};
</script>

<style scoped>
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
